import mixpanel from 'mixpanel-browser'
import { findOutWhichEnv } from 'utils/env'

export const KEY = 'hi@what_connect'

export const defaultAgent = {
  id: '',
  agentName: '',
  agentEmail: '',
  userName: '',
  siteName: '',
  tenantId: '',
  siteId: '',
}

const initToken = () => {
  return new Promise((resolve) => {
    const setToken = (token) => {
      window.localStorage.removeItem('token')
      window.localStorage.setItem('token', token)
      resolve(token)
    }

    const setTenantId = (tenantId) => {
      window.localStorage.removeItem('tenantId')
      window.localStorage.setItem('tenantId', tenantId)
      resolve(tenantId)
    }

    const setDepartament = (department) => {
      window.localStorage.removeItem('departments')
      window.localStorage.setItem('departments', department)
    }

    /**
     * @typedef {object} AgentProps
     * @property {string} AgentProps.id - agent id
     * @property {string} AgentProps.agentName - agent name
     * @property {string} AgentProps.agentEmail - agent e-mail
     * @property {string} AgentProps.userName - agent username
     * @property {string} AgentProps.siteName - site name
     * @property {string} AgentProps.tenantId - tenant id
     * @property {string} AgentProps.siteId - site id
     *
     * @param {AgentProps} params
     */
    const setAgent = ({ id, tenantId, agentName, userName, siteName, siteId, agentEmail }) => {
      const storage = JSON.parse(window.localStorage.getItem(KEY)) || {}

      window.localStorage.setItem(
        KEY,
        JSON.stringify({
          ...storage,
          ...{ id, tenantId, agentName, userName, siteName, siteId, agentEmail },
        }),
      )
    }

    const getMessageDataAccountsSelfConnection = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupAccountsSelfConnection]') !== -1) {
        const kind = data.split('[SupAccountsSelfConnection]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.indexOf('SetDepartments') !== -1) {
          const departmentsFound = data.split('departments=')[1].split(';')[0]
          setDepartament(departmentsFound)
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getMessageDataAccountsConnection = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupAccountsConnection]') !== -1) {
        const kind = data.split('[SupAccountsConnection]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.indexOf('SetDepartments') !== -1) {
          const departmentsFound = data.split('departments=')[1].split(';')[0]
          setDepartament(departmentsFound)
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getMessageDataSentMessage = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupSentMessage]') !== -1) {
        const kind = data.split('[SupSentMessage]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.indexOf('SetDepartments') !== -1) {
          const departmentsFound = data.split('departments=')[1].split(';')[0]
          setDepartament(departmentsFound)
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getMessageDataModelsMessage = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupModelsMessage]') !== -1) {
        const kind = data.split('[SupModelsMessage]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.indexOf('SetDepartments') !== -1) {
          const departmentsFound = data.split('departments=')[1].split(';')[0]
          setDepartament(departmentsFound)
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getMessageDataHsmReports = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupHsmReports]') !== -1) {
        const kind = data.split('[SupHsmReports]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.indexOf('SetDepartments') !== -1) {
          const departmentsFound = data.split('departments=')[1].split(';')[0]
          setDepartament(departmentsFound)
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getMonitoringNumbers = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupMonitoringNumbers]') !== -1) {
        const kind = data.split('[SupMonitoringNumbers]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getMessageDataAnalyticsReports = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupAnalyticReport]') !== -1) {
        const kind = data.split('[SupAnalyticReport]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.indexOf('SetDepartments') !== -1) {
          const departmentsFound = data.split('departments=')[1].split(';')[0]
          setDepartament(departmentsFound)
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getConversionReports = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupConversionReport]') !== -1) {
        const kind = data.split('[SupConversionReport]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.indexOf('SetDepartments') !== -1) {
          const departmentsFound = data.split('departments=')[1].split(';')[0]
          setDepartament(departmentsFound)
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getManagementEvents = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupManagementEvents]') !== -1) {
        const kind = data.split('[SupManagementEvents]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.indexOf('SetDepartments') !== -1) {
          const departmentsFound = data.split('departments=')[1].split(';')[0]
          setDepartament(departmentsFound)
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getWhatsAppExportHistory = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupWhatsAppExportHistory]') !== -1) {
        const kind = data.split('[SupWhatsAppExportHistory]')[1]
        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1].split(';')[0]
          if (tokenFound) {
            setToken(tokenFound)
          }
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1].split(';')[0]
          if (tenantFound) {
            setTenantId(tenantFound)
          }
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1].split(';')[0]
          const agentName = data.split('agentName=')[1].split(';')[0]
          const agentEmail = data.split('agentEmail=')[1].split(';')[0]
          const userName = data.split('username=')[1].split(';')[0]
          const siteName = data.split('siteName=')[1].split(';')[0]
          const siteId = data.split('siteId=')[1].split(';')[0]
          const tenantId = data.split('tenantId=')[1].split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    const getMessageDataFlows = ({ data }) => {
      if (typeof data === 'string' && data.indexOf('[SupWhatsAppFlows]') !== -1) {
        const kind = data.split('[SupWhatsAppFlows]')[1]

        if (kind.indexOf('SetToken') !== -1) {
          const tokenFound = data.split('token=')[1]?.split(';')[0]
          if (tokenFound) setToken(tokenFound)
        }

        if (kind.indexOf('tenantId') !== -1) {
          const tenantFound = data.split('tenantId=')[1]?.split(';')[0]
          if (tenantFound) setTenantId(tenantFound)
        }

        if (kind.includes('agentId')) {
          const id = data.split('agentId=')[1]?.split(';')[0]
          const agentName = data.split('agentName=')[1]?.split(';')[0]
          const agentEmail = data.split('agentEmail=')[1]?.split(';')[0]
          const userName = data.split('username=')[1]?.split(';')[0]
          const siteName = data.split('siteName=')[1]?.split(';')[0]
          const siteId = data.split('siteId=')[1]?.split(';')[0]
          const tenantId = data.split('tenantId=')[1]?.split(';')[0]

          mixpanel.identify(id)
          mixpanel.people.set({ $name: agentName })
          mixpanel.people.set({ $email: agentEmail })
          mixpanel.people.set({ $username: userName })
          mixpanel.people.set({ $company: siteName })
          mixpanel.people.set({ $site: siteId })
          mixpanel.people.set({ $tenant: tenantId })

          setAgent({ id, tenantId, agentName, userName, siteName, siteId, agentEmail })
        }
      }
    }

    window.addEventListener('message', getMessageDataAccountsConnection)
    window.addEventListener('message', getMessageDataHsmReports)
    window.addEventListener('message', getMonitoringNumbers)
    window.addEventListener('message', getMessageDataModelsMessage)
    window.addEventListener('message', getMessageDataSentMessage)
    window.addEventListener('message', getMessageDataAccountsSelfConnection)
    window.addEventListener('message', getMessageDataAnalyticsReports)
    window.addEventListener('message', getConversionReports)
    window.addEventListener('message', getManagementEvents)
    window.addEventListener('message', getWhatsAppExportHistory)
    window.addEventListener('message', getMessageDataFlows)

    if ('parentIFrame' in window) {
      window.parentIFrame.sendMessage({ action: '[DefaultActions]RequestToken' })
      window.parentIFrame.sendMessage({ action: '[DefaultActions]RequestDepartments' })
    }

    const { href } = window.location

    if (href.indexOf('localhost') > -1 || href.indexOf('127.0.0.1') > -1) {
      setToken('TDT04_JftdICOpBcaQSHPtQW5N5TKKPKplMQp_27879_3480')

      const agent = {
        id: '000',
        name: 'Frontend Developer',
        email: 'frontend@hiplatform.com',
        username: 'whatfront',
        company: 'Hi Platform',
        siteId: 'hi-site-id',
        tenant: 'hi-tenant-id',
      }

      mixpanel.identify(agent.id)
      mixpanel.people.set({ $name: agent.name })
      mixpanel.people.set({ $email: agent.email })
      mixpanel.people.set({ $username: agent.username })
      mixpanel.people.set({ $site: agent.siteId })
      mixpanel.people.set({ $company: agent.company })
      mixpanel.people.set({ $tentant: agent.tenant })
      setAgent({
        id: agent.id,
        tenantId: agent.tenant,
        agentName: agent.name,
        userName: agent.username,
        siteName: agent.company,
        siteId: agent.siteId,
        agentEmail: agent.email,
      })
    }

    const getCypressToken = () => {
      const token = window.localStorage.getItem('token')
      if (token) {
        return token
      }
      return null
    }

    if (window.Cypress) {
      setToken(getCypressToken())
    }
  })
}

const getToken = () => {
  const token = window.localStorage.getItem('token')
  if (token) {
    return token
  }
  return null
}

const getPlatform = () => {
  const token = window.localStorage.getItem('token')

  if (token) {
    const splittedToken = token.split('_')

    if (splittedToken.length > 0) {
      return splittedToken[0]
    }
  }

  return ''
}

const getTenantId = () => {
  const tenantId = window.localStorage.getItem('tenantId')
  if (tenantId) {
    return tenantId
  }
  return null
}

/**
 * @typedef {object} AgentProps
 * @property {string} AgentProps.id - agent id
 * @property {string} AgentProps.agentName - agent name
 * @property {string} AgentProps.agentEmail - agent e-mail
 * @property {string} AgentProps.userName - agent username
 * @property {string} AgentProps.siteName - site name
 * @property {string} AgentProps.tenantId - tenant id
 * @property {string} AgentProps.siteId - site id
 *
 * @returns {AgentProps} agent
 */
const getAgent = () => {
  const storage = JSON.parse(window.localStorage.getItem(KEY)) || defaultAgent

  return storage
}

const getMixpanelToken = () => {
  if (findOutWhichEnv() === 'PROD') {
    return '82d92747337cf348bca4b31c6ab49ab7'
  }
  return 'f6588e75767bcb78ecbe91b9dd54ac4e'
}

export { initToken, getToken, getTenantId, getPlatform, getMixpanelToken, getAgent }
